import { RootState } from '@tabeeb/store'

export const getDialogState = (state: RootState) => state.tenantForms.sncDialogState
